var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "custom-payments") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-3169.000000, -869.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "custom-payments",
    transform: "translate(3169.000000, 869.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 461,
    cy: 468,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Payment_line_55",
    transform: "translate(100.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(94.827586, 34.482759)",
    stroke: "#000000",
    strokeWidth: 17.2413793
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.948276,413.793103 L168.318966,437.758621 C165.62931,438.982759 162.62931,439.655172 159.482759,439.655172 C150.689655,439.655172 143.137931,434.396552 139.784483,426.853448 L1.87931034,107.939655 C0.672413793,105.258621 0,102.275862 0,99.137931 C0,90.3793103 5.21551724,82.8448276 12.7241379,79.4741379 L185.12931,1.89655172 C187.818966,0.672413793 190.818966,0 193.965517,0 C202.758621,0 210.310345,5.25862069 213.663793,12.8017241 L295.62931,204.525862",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.413793,
    y1: 350.715517,
    x2: 120.62931,
    y2: 382.568966,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.724138,359.551724 L157.793103,250.525862 C156.12931,247.87069 155.172414,244.741379 155.172414,241.37931 C155.172414,231.862069 162.896552,224.137931 172.413793,224.137931 C178.594828,224.137931 183.948276,227.413793 187.043103,232.258621 C198.318966,249.896552 232.87069,302.336207 232.87069,302.336207 C232.87069,302.336207 283.75,283.577586 301.715517,278.724138 C307.491379,277.155172 311.232759,276.034483 318.775862,276.034483 C330.62931,276.034483 338.844828,283.706897 345.431034,293.293103 C359.913793,314.37931 369.25,339.862069 372.439655,351.336207 C381.198276,382.801724 381.732759,411.896552 381.732759,411.896552",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.103448,439.655172 C283.137931,439.655172 265.172414,439.198276 232.758621,422.413793 C217.672414,414.603448 189.655172,401.939655 189.655172,370.689655 C189.655172,344.827586 196.353448,334.956897 203.931034,323.646552",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.5,
    y1: 165.982759,
    x2: 246.275862,
    y2: 186.517241,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.655172,
    y1: 54.0689655,
    x2: 227.87931,
    y2: 143.474138,
    id: "Path"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "448.275862 0 431.034483 0 431.034483 17.2413793 448.275862 17.2413793"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "482.758621 17.2413793 465.517241 17.2413793 465.517241 34.4827586 482.758621 34.4827586"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "396.551724 51.7241379 379.310345 51.7241379 379.310345 68.9655172 396.551724 68.9655172"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "500 51.7241379 482.758621 51.7241379 482.758621 68.9655172 500 68.9655172"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "448.275862 103.448276 431.034483 103.448276 431.034483 120.689655 448.275862 120.689655"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "413.793103 86.2068966 396.551724 86.2068966 396.551724 103.448276 413.793103 103.448276"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "482.758621 86.2068966 465.517241 86.2068966 465.517241 103.448276 482.758621 103.448276"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "413.793103 17.2413793 396.551724 17.2413793 396.551724 34.4827586 413.793103 34.4827586"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "206.896552 465.517241 189.655172 465.517241 189.655172 482.758621 206.896552 482.758621"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "163.793103 362.068966 146.551724 362.068966 146.551724 379.310345 163.793103 379.310345"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "103.448276 422.413793 86.2068966 422.413793 86.2068966 439.655172 103.448276 439.655172"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "120.689655 379.310345 103.448276 379.310345 103.448276 396.551724 120.689655 396.551724"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "120.689655 465.517241 103.448276 465.517241 103.448276 482.758621 120.689655 482.758621"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "163.793103 482.758621 146.551724 482.758621 146.551724 500 163.793103 500"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "43.1034483 172.413793 25.862069 172.413793 25.862069 189.655172 43.1034483 189.655172"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "77.5862069 189.655172 60.3448276 189.655172 60.3448276 206.896552 77.5862069 206.896552"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "181.034483 34.4827586 163.793103 34.4827586 163.793103 51.7241379 181.034483 51.7241379"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "146.551724 17.2413793 129.310345 17.2413793 129.310345 34.4827586 146.551724 34.4827586"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "25.862069 137.931034 8.62068966 137.931034 8.62068966 155.172414 25.862069 155.172414"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "17.2413793 103.448276 0 103.448276 0 120.689655 17.2413793 120.689655"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "43.1034483 34.4827586 25.862069 34.4827586 25.862069 51.7241379 43.1034483 51.7241379"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "77.5862069 17.2413793 60.3448276 17.2413793 60.3448276 34.4827586 77.5862069 34.4827586"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "25.862069 68.9655172 8.62068966 68.9655172 8.62068966 86.2068966 25.862069 86.2068966"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "112.068966 8.62068966 94.8275862 8.62068966 94.8275862 25.862069 112.068966 25.862069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.293103,275.12931 C295.965517,269.396552 301.724138,259.318966 301.724138,247.844828 C301.724138,230.689655 288.594828,215.517241 274.310345,215.517241 C259.086207,215.517241 232.810345,241.37931 216.775862,241.37931 C203.284483,241.37931 189.655172,226.62069 189.655172,209.051724 C189.655172,196.37931 196.663793,185.422414 206.887931,180.12069 L231.793103,167.189655 C235.974138,165.017241 240.689655,163.793103 245.689655,163.793103 C249.077586,163.793103 252.336207,164.353448 255.387931,165.396552",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 17.2413793
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.275862,287.577586 C233.25,291.068966 239.241379,293.103448 245.689655,293.103448 C249.439655,293.103448 253.146552,292.362069 256.465517,291.103448",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 17.2413793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.508621,
    y1: 174.603448,
    x2: 203.12931,
    y2: 150.862069,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 17.2413793
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.5f66f771103f529889c21a60254903c0.svg";
export { ForwardRef as ReactComponent };